<template>
  <!-- 合作伙伴 -->
  <div class="partner">
    <p style="padding: 5px;">请上传合作伙伴LOGO,最多20张(16:11效果最佳)</p>
    <el-upload action="#" :limit="20" :file-list="fileList" list-type="picture-card" :http-request="uploadfile" :multiple='false' :auto-upload="true">
      <i slot="default" class="el-icon-plus"></i>
      <template slot="file" slot-scope="{file}">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="view(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
            <i class="el-icon-download"></i>
          </span>
          <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </template>
    </el-upload>

    <el-dialog v-dialogDrag :visible.sync="dialogVisible">
      <img style=" width: 100%;;height: 24rem" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>

</template>

<script>
import api from '@/apis/recommend/partner'
import upapi from '@/apis/upload'
export default {
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      fileList: [
        // {
        //   name: 'food.jpeg',
        //   url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
        // },
      ],
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {

    getlist(){
      api
        .list({
          params: {
            limit: 20,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            if (res.data.list.length) {

              this.fileList = res.data.list
            }
          } else {
            this.$message.error(res.message)
          }
        })      
    },

    handleRemove(file) {
      // console.log(file)
      return this.$confirm(`确定移除此图片？`).then(() => {
        this.fileList.map((item, index) => {
          if (item.id == file.id) {
            // 删除
            api.del([file.id]).then((res) => {
              if (res.code === 10000) {
                this.getlist()
                this.$message.success(res.message)
              } else {
                this.$message.error(res.message)
              }
            })
            this.fileList.splice(index, 1)

            upapi.del({ params: { filePath: file.url } }).then(
            //   (res) => {
            //   if (res.code == 10000) {
            //     //  this.$message.success(res.message)
            //     
            //   } else {
            //     this.$message.error(res.message)
            //   }
            // }
            )
          }
        })
      })
    },
    view(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleDownload(file) {
      open(file.url)
    },
    save() {
      api.save(this.fileList).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this.getlist()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //上传图片
    uploadfile(val) {
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          // this.$message.success(res.message)

          this.fileList.push({
            name: val.file.name,
            url: res.data,
            uid: val.file.uid,
          })

          this.save()
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less">
.partner {
  .el-upload--picture-card {
    background-color: #00a1ff38;
  }

  .el-upload-list li {
    width: 16rem !important;
    height: 11rem !important; margin: 10px; display: inline-flex; align-items: center; justify-content: center; vertical-align:middle;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .el-upload-list__item{ border-radius: 0;}
  .el-upload--picture-card {
    font-size: 2rem !important;
    width: 16rem !important;
    height: 11rem !important; margin: 10px;
    line-height:11rem !important;
    text-align: center; border: #555e86 dashed 1px; font-size: 2rem; border-radius: 0;
  }
}
</style>